import "regenerator-runtime/runtime";
import * as React from "react";
import ReactDOM from "react-dom";
import MainApp from "./components/MainApplication";

ReactDOM.render(
  <React.StrictMode>
    <MainApp />
  </React.StrictMode>,
  document.getElementById("root")
);
